export type TariffLimitErrorCode =
  | 'LIMIT_EXCEEDED'
  | 'FEATURE_LOCKED'
  | 'SUBSCRIPTION_EXPIRED';

export interface TariffLimitPayload {
  error: TariffLimitErrorCode;
  message: string;
  limit?: number;
  current?: number;
  plan?: string;
  upgrade_url?: string;
}

const TARIFF_LIMIT_ERRORS = new Set<string>([
  'LIMIT_EXCEEDED',
  'FEATURE_LOCKED',
  'SUBSCRIPTION_EXPIRED',
]);

export class ApiError extends Error {
  readonly code?: string;
  readonly payload?: TariffLimitPayload;

  constructor(message: string, code?: string, payload?: TariffLimitPayload) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.payload = payload;
  }
}

export function isTariffLimitError(error: unknown): error is ApiError {
  return (
    error instanceof ApiError &&
    typeof error.code === 'string' &&
    TARIFF_LIMIT_ERRORS.has(error.code)
  );
}

export function normalizeUpgradeUrl(url?: string): string {
  if (!url) {
    return '/settings?tab=billing';
  }
  if (url.includes('tab=billing')) {
    return url;
  }
  if (url === '/settings/billing' || url.startsWith('/settings/billing')) {
    return '/settings?tab=billing';
  }
  return url;
}

export function parseTariffLimitPayload(json: unknown): TariffLimitPayload | null {
  if (!json || typeof json !== 'object') {
    return null;
  }
  const record = json as Record<string, unknown>;
  const error = record.error;
  if (typeof error !== 'string' || !TARIFF_LIMIT_ERRORS.has(error)) {
    return null;
  }
  const message = typeof record.message === 'string'
    ? record.message
    : 'Достигнут лимит тарифного плана.';

  return {
    error: error as TariffLimitErrorCode,
    message,
    limit: typeof record.limit === 'number' ? record.limit : undefined,
    current: typeof record.current === 'number' ? record.current : undefined,
    plan: typeof record.plan === 'string' ? record.plan : undefined,
    upgrade_url: normalizeUpgradeUrl(
      typeof record.upgrade_url === 'string' ? record.upgrade_url : undefined,
    ),
  };
}
